<template>
  <div>
    <Producao
      tipo-producao="bar"
      titulo="Bar"
      subtitulo="Pedidos enviados para produção do bar"
      :exibir-mesas-atalho="false"
    />
  </div>
</template>

<script>
import Producao from "@/modules/Restaurante/pages/Producao/Index.vue";

export default {
  name: "app-restaurante-bar",
  components: {
    Producao,
  },
};
</script>
